var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-card",
    {
      attrs: {
        id: "cardQuizAdvice",
        title: _vm.$t("completeYourHealthProfile")
      }
    },
    [
      _c("div", {
        staticClass: "mb-3",
        domProps: { innerHTML: _vm._s(_vm.$t("fillQuizAdvice")) }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "base-button",
            {
              staticClass: "mt-3",
              attrs: { white: "" },
              on: {
                click: function($event) {
                  return _vm.goToSection(_vm.QUIZ_PATH)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("complete")))]
          ),
          _vm._v(" "),
          _c(
            "base-button",
            {
              staticClass: "mt-3",
              attrs: {
                backgroundColor: _vm.BACKGROUND_COLOUR,
                textColor: _vm.GRAY_COLOUR,
                borderColor: _vm.BACKGROUND_COLOUR
              },
              on: {
                click: function($event) {
                  return _vm.remindLater()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("later")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a987df54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a987df54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/quiz/ClinicHistoryFillQuizAdvice.vue
// module id = 3799
// module chunks = 32